import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

interface DefaultComProps {
    existingFormId: string;
    existingTeamId: string;
    createIntegration: any;
    modalVisible: boolean;
    setModalVisible: any;
}

export default function DefaultCom({ existingFormId, existingTeamId, createIntegration, modalVisible, setModalVisible }: DefaultComProps) {
    const [formId, setFormId] = useState(existingFormId || '');
    const [teamId, setTeamId] = useState(existingTeamId || '');

    function createDefaultIntegration() {
        createIntegration({
            formId: formId,
            teamId: teamId,
            appName: 'default'
        });
    }

    return (
        <Dialog open={modalVisible} onOpenChange={setModalVisible}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Connect Default</DialogTitle>
                    <DialogDescription>
                        Enter your Default Form ID and Team ID to connect scheduling.
                    </DialogDescription>
                </DialogHeader>

                <div className="grid gap-4 py-4">
                    <div className="space-y-2">
                        <Input
                            value={formId}
                            onChange={(e) => setFormId(e.target.value)}
                            placeholder="Form ID"
                        />
                    </div>
                    <div className="space-y-2">
                        <Input
                            value={teamId}
                            onChange={(e) => setTeamId(e.target.value)}
                            placeholder="Team ID"
                        />
                    </div>
                    <a
                        href="https://docs.default.com/article/forms-sdk#implementation"
                        target="_blank"
                        className="text-sm text-blue-600 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-300 transition-colors"
                    >
                        How to find your Default Form ID and Team ID
                    </a>
                </div>

                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => setModalVisible(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={createDefaultIntegration}
                    >
                        Connect
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
